module.exports = "<lp2-header></lp2-header>\n<lp2-title-bar page-title=\"<%= i18n.studyBundle.studentInfo.title %>\"></lp2-title-bar>\n<lp2-study-bundle></lp2-study-bundle>\n<lp2-footer></lp2-footer>\n";


//////////////////
// WEBPACK FOOTER
// ./js/home/templates/AngularHome.html
// module id = 696
// module chunks = 23